export default "__VITE_ASSET__BvejBI_O__"